import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import { Header, Footer } from './headerFooter';
import './custom.scss';

function PremiumUpgrade() {
  return (
    <div id="root">
      <Header />
      <main className="main-container">
        <Container className="py-4">
          <h1 className="mb-3">Premium πρόσβαση</h1>
          <p className="mb-3">
            Για να αποκτήσετε πρόσβαση στο εργαλείο <strong>Εκτιμήσεις πιθανοτήτων πρόσληψης</strong>,
            χρειάζεστε ενεργή <strong>Premium</strong> συνδρομή.
          </p>
          <p className="mb-4">
            Στη σελίδα αυτή μπορείτε να ολοκληρώσετε την πληρωμή σας και να ενεργοποιήσετε τον λογαριασμό σας.
          </p>
          <Button variant="primary" size="lg" disabled>
            Σε λίγο διαθέσιμη πληρωμή
          </Button>
        </Container>
      </main>
      <Footer />
    </div>
  );
}

export default PremiumUpgrade;

